export const wysiwygSettings = {
  maxHeight: "800px",
  hideModules: {
    unorderedList: true,
    code: true,
    removeFormat: true,
    table: true,
    image: true,
    separator: true,
  },
  forcePlainTextOnPaste: true,
};

export const file_stack_api_key = process.env.VUE_APP_FILESTACK_API_KEY;
export const user_flow_token = process.env.VUE_APP_USERFLOW_TOKEN;
/** Legacy MShift quote UI + quote APIs are off by default (no env toggle). */
export const DISABLE_LEGACY_MSHIFT_QUOTING = true;

export const SHOW_BROKER_CUSTOMER_OPTIONAL_UI = false;

/** Cyber PreCheck UI is hidden product-wide. Backend models/APIs are left intact. */
export const SHOW_CYBER_PRE_CHECK = false;
